

import { useQuery } from "@tanstack/react-query";
import type { AdminView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type AdminSessionResponse = {
  admin?: AdminView;
  firebaseToken?: string | null;
};

export function useSessionQuery() {
  const query = useQuery({
    queryKey: queryKeys.admin.session(),
    queryFn: () => apiJsonClient<AdminSessionResponse>(`${endpoints.admin.auth.me}?includeFirebaseToken=true`),
    refetchInterval: 50 * 60 * 1000, // refresh before Firebase custom token expires (1h)
    refetchIntervalInBackground: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
